/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/

import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

export const UserFavoriteServiceGet = {
  id: 'user.favorite-service.get',
  tag: 'User',
  summary: 'Get User Favorite Services',
  description: 'Fetches the list of favorite services for the authenticated user',
  method: 'get',
  flags: { isAuthorized: true },
  route: () => `/user/favorite/service`,
  response: {
    200: {
      description: 'List of favorite services',
      content: {
        'application/json': {
          schema: z.array(
            z.strictObject({
              id: ZodTypes.Id,
              name: ZodTypes.TrimmedString,
              type: ZodTypes.ServiceType,
              organization: z.strictObject({
                id: ZodTypes.Id,
                name: ZodTypes.TrimmedString,
              }),
              project: z.strictObject({
                id: ZodTypes.Id,
                name: ZodTypes.TrimmedString,
              }),
            }),
          ),
        },
      },
    },
  },
} as const satisfies Endpoint;
